$(document).ready(function () {
  /*Scroll top*/
  var scrollTop = $(".scrollTop");
  $(window).scroll(function () {
    var topPos = $(this).scrollTop();
    if (topPos > 0) {
      $(scrollTop).css("opacity", "1", "transform", "scale(1)");
      $(".scrollTop").addClass("vis");
    } else {
      $(scrollTop).css("opacity", "0", "transform", "scale(0)");
      $(".scrollTop").removeClass("vis");
    }
  });
  $(scrollTop).click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );
    return false;
  });



  /*-----MOBILE FOOTER LINKS-----*/
  $(".ft-title").click(function () {
    if ($(window).width() < 576) {
      $(this).toggleClass("linkopen");
      $(this).next('ul').stop().slideToggle();
      $(this).next('.ft-body').stop().slideToggle();
    }
  });
  
    /* preheader slider */
  $('.topslider').slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay:false,
  });

 /*------ fancybox -------- */
  $('[data-fancybox]').fancybox({
                touch: false,
                smallBtn: true
            });

 /*------------------*/
  //industry slider
	   $('.industry-ul').slick({
      arrows: true,
      dots: false,
      slidesToShow: 7,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
      {
        breakpoint: 1440,
        settings: {
          slidesToShow: 5
        }
      },
      {
        breakpoint:992,
        settings: {
          slidesToShow: 4
        }
      },
      {
        breakpoint:768,
        settings: {
          slidesToShow: 3
        }
      },
       {
        breakpoint:576,
        settings: {
          slidesToShow: 2
        }
      }
      ]
  });

  // brands 
    //industry slider
	   $('.brand-ul').slick({
      arrows: true,
      dots: false,
      slidesToShow: 5,
      slidesToScroll: 1,
      horizontal: true,
      infinite: true,
      autoplay: false,
      pauseOnHover: false,
      autoplaySpeed: 3000,
      responsive: [
      
      {
        breakpoint:992,
        settings: {
          slidesToShow:3
        }
      },
      
       {
        breakpoint:576,
        settings: {
          slidesToShow: 2
        }
      }
      ]
  });

});
